import EquipmentAndMaterialCardApp from '../Functionality/EquipmentMaterialCardApp';
import DisplayView from '../../../../../components/DisplayView';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
import CustomButtonLink from './../../../../../components/buttons/CustomButtonLink';
import NotInformation from './../../../../../components/NotInformation';
import {
    ArrowRightIcon,
    CubeIcon, IconMaterialType,
    ModelIcon,
    NumericFieldChip,
    SerialIcon,
} from '../../../../../components/buttons/IconButtons';
import RowCardText from './../../../../../components/RowCardText';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
import CustomChip from './../../../../../components/CustomChip';
import ButtonActionsCard from './../../../../../components/buttons/ButtonActionsCard';
import { status } from '../../../../../enums/statusEnum';
import { CustomCardGrid } from './../../../../../components/CustomCardGrid';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import routes from '../../../../../../src/Routes/routes';
import { colors } from './../../../../../enums/colors';
import defaultImage from '../../../../../assets/IconsTables/ic-tools.svg';
import { URL } from '../../../../../Apis/Constants';
import CustomTooltip from '../../../../../components/CustomTooltip';
import {MATERIAL_TYPE} from "../Model/Model";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const EquipmentAndMaterialCards = (props) => {
    const {
        selectForDelete,
        setSearch,
        view,
        setBodyForExport,
        setView,
        setSelectForDelete,
        modified,
        setModified,
        contractorId,
        supplierId,
    } = props;
    const {
        handleCheckboxChange,
        isAllChecked,
        pagination,
        elementRef,
        searchResults,
        page,
        rowsPerPage,
        searchId,
        searchElement,
        option,
        setSimpleSearch,
        disabled,
        handleDeleteAll,
        navigate,
        setSearchElement,
        t,
        setSearchResults,
    } = EquipmentAndMaterialCardApp({
        selectForDelete,
        setSelectForDelete,
        view,
        modified,
        setModified,
        setBodyForExport,
        contractorId,
        supplierId,
    });

    return (
        <>
            <div className='d-flex pt-2'>
                <DisplayView view={view} setView={setView} className={''} />
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        searchElement={searchElement}
                        setSearchResults={setSearchResults}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                    />
                </div>
            </div>
            <>
                {searchResults?.content?.length > 0 ? (
                    <>
                        <div className={''}>
                            <CustomCheckbox
                                id={'cb_eamc_all_checked'}
                                trans={'de_/_select_all'}
                                name={'isAllChecked'}
                                checked={isAllChecked}
                                onChange={(e) => {
                                    handleDeleteAll(e);
                                }}
                            />
                        </div>
                        <div className='panelTables' ref={elementRef}>
                            <div className='row'>
                                {searchResults?.content?.map((item, index) => (
                                    <CustomCardGrid
                                        isCheckboxShow={true}
                                        itemId={item?.id}
                                        checked={selectForDelete?.includes(item?.id)}
                                        onCheckboxChange={handleCheckboxChange}
                                        disabled={disabled}
                                        statusColor={colors.secondary100}
                                        fontColor={colors.secondary700}
                                        borderColor={colors.secondary150}
                                        chipVariant={'large'}
                                        statusName={t(status[item?.statusId]) || EMPTY_VALUES.DEFAULT}
                                        srcImage={
                                            item?.fileUploadDto ? URL + item.fileUploadDto.filePath : defaultImage
                                        }
                                        isSquareImg={true}
                                        isDefaultIcon={true}
                                        btnActions={
                                            <>
                                                <ButtonActionsCard
                                                    id={`btn_eamc_actions_card_${index + 1}`}
                                                    name={'details'}
                                                    Icon={ArrowRightIcon}
                                                    onClick={() =>
                                                        navigate(`${routes.equipmentAndMaterial.update}${item?.id}`)
                                                    }
                                                />
                                            </>
                                        }
                                    >
                                        <div className='d-flex flex-column justify-content-between'>
                                            <div className='text-center ibl-font-w-600'>
                                                <CustomTooltip
                                                    text={item?.name}
                                                    classes={`fs-14px ibl-font-w-600 font-color-general-950 text-ellipsis-1-row pt-1`}
                                                    showIfTruncated={true}
                                                    tooltipClasses={'p-0'}
                                                />
                                            </div>
                                            <div className='d-flex justify-content-center py-2 gap-2 border-bottom-shades-300 minh-40px'>
                                                {item?.categoryName && (
                                                    <CustomChip
                                                        background={colors.secondary100}
                                                        borderColor={colors.secondary150}
                                                        fontColor={colors.secondary700}
                                                        legend={item?.categoryName}
                                                    />
                                                )}
                                                {item?.subCategoryName && (
                                                    <CustomChip
                                                        background={colors.primary100}
                                                        borderColor={colors.primary300}
                                                        fontColor={colors.primary700}
                                                        legend={item?.subCategoryName}
                                                    />
                                                )}
                                            </div>
                                        </div>

                                        <div className='px-2 mt-3'>
                                            <RowCardText
                                                icon={<NumericFieldChip className='w-h-20px' />}
                                                title={t('code')}
                                                value={
                                                    <CustomTooltip
                                                        text={item?.code}
                                                        classes={` text-ellipsis-1-row pt-1`}
                                                        showIfTruncated={true}
                                                        tooltipClasses={'p-0'}
                                                    />
                                                }
                                            />

                                            <RowCardText
                                                icon={<CubeIcon className='w-h-20px' />}
                                                title={t('brand')}
                                                value={
                                                    <CustomTooltip
                                                        text={item?.brand}
                                                        classes={` text-ellipsis-1-row pt-1`}
                                                        showIfTruncated={true}
                                                        tooltipClasses={'p-0'}
                                                    />
                                                }
                                                className='py-1'
                                            />
                                            <RowCardText
                                                icon={<ModelIcon className='w-h-20px' />}
                                                title={t('model')}
                                                value={
                                                    <CustomTooltip
                                                        text={item?.model}
                                                        classes={` text-ellipsis-1-row pt-1`}
                                                        showIfTruncated={true}
                                                        tooltipClasses={'p-0'}
                                                    />
                                                }
                                                className='py-1'
                                            />
                                            <RowCardText
                                                icon={<SerialIcon className='w-h-20px' />}
                                                title={t('serial_number').toLowerCase()}
                                                value={
                                                    <CustomTooltip
                                                        text={item?.serialNumber}
                                                        classes={` text-ellipsis-1-row pt-1`}
                                                        showIfTruncated={true}
                                                        tooltipClasses={'p-0'}
                                                    />
                                                }
                                                className='py-1'
                                            />
                                            <RowCardText
                                                icon={<IconMaterialType className='w-h-20px' />}
                                                title={t('material_type')}
                                                value={
                                                    <CustomTooltip
                                                        text={t(MATERIAL_TYPE[item?.equipmentOwner].trans)}
                                                        classes={` text-ellipsis-1-row pt-1`}
                                                        showIfTruncated={true}
                                                        tooltipClasses={'p-0'}
                                                    />
                                                }
                                            />
                                        </div>
                                    </CustomCardGrid>
                                ))}
                            </div>
                        </div>
                    </>
                ) : (
                    <NotInformation card={true}>
                        <div className={'warning-text'}>
                            <p>{t('you_haven_not_created_any_equipment_or_material')}</p>
                        </div>

                        <CustomButtonLink
                            splitName={false}
                            id={'btn_eamc_create'}
                            card={true}
                            onClick={() => navigate(routes.equipmentAndMaterial.create)}
                            name={'create_new_equipment_or_material'}
                        />
                    </NotInformation>
                )}
            </>
            {pagination()}
        </>
    );
};

export default EquipmentAndMaterialCards;
